import React from 'react';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box } from '@mui/material';
import { Button, Typography } from '../..';
import { PaginationProps } from './Table.types';

// Pagination Component
export const TablePagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  disableNext,
  disablePrevious,
}) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (!totalPages) {
      if (disableNext) return;
      onPageChange(currentPage + 1);
    } else if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const nextDisabled = totalPages ? currentPage >= totalPages : disableNext;
  const previousDisabled = totalPages === undefined ? disablePrevious : currentPage <= 1;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
      {totalPages && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mx: 2 }}>
          <Typography style={{ fontSize: '14px', color: '#475467', userSelect: 'none' }}>
            Page {currentPage} of {totalPages}
          </Typography>
        </Box>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <Button
          color="secondary"
          variant="contained"
          size="small"
          onClick={handlePrevious}
          disabled={previousDisabled}
          startIcon={<ChevronLeft />}
        >
          Previous
        </Button>
        <Button
          color="secondary"
          variant="contained"
          size="small"
          onClick={handleNext}
          disabled={nextDisabled}
          endIcon={<ChevronRight />}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};
